/* @flow */
import * as React from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';

import DashboardStore from 'stores/DashboardStore';
import type { WidgetItem } from 'stores/DashboardStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

export type FullScreenViewerProps = {
  widgetRenderer: (widget: WidgetItem, isFullScreen?: boolean, forceSize?: string) => React.Node,
};
type InjectedProps = { dashboardStore: DashboardStore } & TranslatorProps;

@translate()
@inject('dashboardStore')
@observer
export default class FullScreenViewer extends ComponentWithInjectedProps<
  FullScreenViewerProps,
  {},
  InjectedProps
> {
  @computed get active(): boolean {
    return !!this.props.dashboardStore.fullScreenWidget;
  }

  handleDialogClose = () => {
    this.props.dashboardStore.fullScreenWidget = null;
  };

  render() {
    const {
      dashboardStore: { fullScreenWidget },
      widgetRenderer,
    } = this.props;

    if (this.active) {
      return (
        <Dialog open fullScreen onClose={this.handleDialogClose}>
          {widgetRenderer(
            { widget: fullScreenWidget, position: 1, variant: 'default' },
            true,
            'canvas'
          )}
        </Dialog>
      );
    }

    return null;
  }
}
